import { render, staticRenderFns } from "./ranking-list.vue?vue&type=template&id=a552b360&scoped=true"
import script from "./ranking-list.vue?vue&type=script&lang=js"
export * from "./ranking-list.vue?vue&type=script&lang=js"
import style0 from "./ranking-list.vue?vue&type=style&index=0&id=a552b360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a552b360",
  null
  
)

export default component.exports